// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3CzGz","overflowing":"ReadFullNote_overflowing__3TXNR"};